import React from "react"
import LogoSvg from "../static/logo.svg"
import Redes from "../static/redes2.png"
import {Link} from "react-router-dom";

//<Link to="/politica">Términos y condiciones</Link>

export default function Footer() {
  return (
    <footer>
        <img src={LogoSvg} className="logo"/>
        <div className="middle">
          <ul>
            <li>
              <a href="https://pulso.social/terminos.html" target="_blank">Términos y condiciones</a>
            </li>
          </ul>
        </div>
        <div className="right">
          <a href="https://www.facebook.com/pulso54/" target="_blank">
            <img src={Redes} />
          </a>
        </div>  
  
    </footer> 
  )
}